import React, { useState, useEffect, useRef, useContext } from 'react';
import { useStake, useInterval } from '../../contract';
import { ethers } from 'ethers';
import toast from 'react-hot-toast'
import { current } from '@reduxjs/toolkit';
import { useAddress, useChainId } from "@thirdweb-dev/react";

const Staking = () => {
    const address = useAddress()
    const chainId = useChainId()

    const textRef = useRef()
    const [isSubmiting, setIsSubmiting] = useState(false)
    const [balance, setBalance] = useState(0)
    const [staked, setStaked] = useState(0)
    const [earn, setEarn] = useState(0)
    const [dailyPotential, setDailyPotential] = useState(0)
    const [action, setAction] = useState('stake')
    const [refresh, setRefresh] = useState(0)
    const [isApproved, setIsApproved] = useState(false)
    const [rewardCooldown, setRewardCooldown] = useState(0)
    const [stakedCooldown, setStakedCooldown] = useState(0)

    const {
        approve,
        isApprove,
        stake,
        withdraw,
        balanceOf,
        stakedAmount,
        earned,
        getReward,
        dailyReward,
        claimCooldown,
        stakeCooldown
    } = useStake()

    useEffect(() => {
        claimCooldown(address)
        .then(_cooldown => setRewardCooldown(_cooldown))
        .catch(e => console.log(e))

        stakeCooldown(address)
        .then(_cooldown => setStakedCooldown(_cooldown))
        .catch(e => console.log(e))

        balanceOf(address)
        .then(_balance => setBalance(ethers.utils.formatUnits(_balance, 9)))
        .catch(e => console.log(e))

        stakedAmount(address)
        .then(_staked => setStaked(ethers.utils.formatUnits(_staked, 9)))
        .catch(e => console.log(e))

        earned(address)
        .then(_earn => setEarn(ethers.utils.formatUnits(_earn, 9)))
        .catch(e => console.log(e))

        dailyReward(address)
        .then(_estimate => setDailyPotential(ethers.utils.formatUnits(_estimate, 9)))
        .catch(e => console.log(e))
    }, [address, chainId, refresh]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        isApprove()
        .then(res => {
            if (res === false) setIsApproved(true)
        })
        .catch(e => console.log(e))
    }, [])

    useInterval(
        () => {
        earned(address)
            .then(_earn => setEarn(ethers.utils.formatUnits(_earn, 9)))
            .catch(e => e)
        },
        staked > 0 ? 30000 : null
    )

    const onApprove = async () => {
        const amount = textRef.current.value
        console.log(amount)

        if (amount === '') return

        setIsSubmiting(true)
        try {
        await approve()
        setIsApproved(true)
        } catch (e) {
        console.log(e)
        }
        setIsSubmiting(false)
    }

    const onSubmit = async () => {
        const amount = textRef.current.value

        if (amount === '') return

        setIsSubmiting(true)
        try {
        await stake(amount)
        setRefresh(new Date())
        toast('Staked successfully.')
        } catch (e) {
        console.log(e)
        }
        setIsSubmiting(false)
    }

    const onSubmitUnstake = async () => {
        const amount = textRef.current.value

        if (amount === '') return

        setIsSubmiting(true)
        try {
            await withdraw(amount)
            setRefresh(new Date())
            toast('Unstaked successfully.')
        } catch (e) {
            let days = stakedCooldown.split(' ')[0];
            let number = parseInt(days);
            const alert = 'You cannot withdraw as the withdraw cooldown is active'
            const real = `Your tokens will be available to withdraw in ${number + 1} ` + (number == 0 ? "day" : "days")
            if (e.toString().includes(alert))
                toast.error(real)            
        }
        setIsSubmiting(false)
    }

    const handleRewards = async () => {
        try {
            await getReward()
            setRefresh(new Date())
            toast('Reward received successfully.')
        } catch (e) {
            let days = rewardCooldown.split(' ')[0];
            let number = parseInt(days);
            const alert = 'You cannot claim rewards as the lock is still active'
            const real = `Your rewards will be available in ${number + 1} ` + (number == 0 ? "day" : "days")
            if (e.toString().includes(alert))
                toast.error(real)
        }
    }

    const handleTab = action => setAction(action)

    const handleMax = async () => {
        if (action === 'stake') {
            textRef.current.value = balance
        }
        if (action === 'unstake') {
            textRef.current.value = staked
        }
    }
    const onChangeName = (value) => {
        console.log('On Change Name')
        textRef.current.value = value
    }
    return (
        <div id="main">
            <div id="main-content">
                <div id="main-page-content" className="content-max-width">
                    <div className="content-row row_padding_top row_padding_left row_padding_right row_padding_bottom full light-section" data-bgcolor="#eee">
                        <div className="one_third">
                            <h6 className="has-mask">/ 24% APY</h6>
                        </div>
                        <div className="one_third last">
                            <div className="one_half">
                                <h6 onClick={() => handleTab('stake')}
                                    className={`has-mask ${action === 'stake' ? 'active' : ''}`}>Stake</h6> 
                            </div>
                            <div className="one_half last">
                                <h6 onClick={() => handleTab('unstake')}
                                    className={`has-mask ${action === 'unstake' ? 'active' : ''}`}>Unstake</h6> 
                            </div>      
                        </div>
                        <hr />
                        <hr />
                        <div className="one_third">
                            <h3 className="has-mask-fill no-margins">Stake HMMM</h3>
                        </div>
                        <div className="two_third last">
                            <div className="one_third has-animation"  data-delay="100">
                                <div className="inline-boxes">
                                    <div className="">
                                        <h3 className="no-margins"><span>24%</span></h3>
                                        <p>Current APY</p>
                                    </div>
                                </div> 
                            </div>
                            <div className="one_third has-animation"  data-delay="200">
                                <div className="inline-boxes">
                                    <div className="">
                                        <h3 className="no-margins">$0.10</h3>
                                        <p>Current Price</p>
                                    </div>
                                </div>
                            </div>
                            <div className=" one_third last has-animation"  data-delay="300">
                                <div className="inline-boxes">
                                    <div className="">
                                        <h3 className="no-margins">2.5M</h3>
                                        <p>Total Staked</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="one_third" ></div>
                        <div className="two_third last">
                            <div id="contact-formular">
                                <div id="message"></div>
                                <form name="staking" id="stakingForm">                             
                                    <div className="name-box has-animation" data-delay="100">        
                                        <input name="name" type="number" id="name" size="30" ref={textRef} onChange={e => onChangeName(e.target.value)} placeholder="Amount" />
                                        <label className="input_label" ></label>
                                    </div>                      
                                    <div className="button-box has-animation" data-delay="100">             
                                        <div className="clapat-button-wrap parallax-wrap hide-ball">
                                            <div className="clapat-button parallax-element">
                                                <div className="button-border rounded parallax-element-second">
                                                    <input type="button" onClick={handleMax} className="" id="" value="Max Amount" />
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                    <div className="button-box has-animation" data-delay="100">             
                                        <div className="clapat-button-wrap parallax-wrap hide-ball">
                                            <div className="clapat-button parallax-element">
                                                <div className="button-border rounded parallax-element-second">
                                                {action === 'stake' ? (
                                                    isApproved === true ? (
                                                        <input type="button" className="" value="STAKE HMMM" onClick={onSubmit} />
                                                    ) : (
                                                        <input type="button" className="" value="APPROVE" onClick={onApprove} />
                                                    )
                                                ) : (
                                                    <input type="button" className="" value="UNSTAKE HMMM" onClick={onSubmitUnstake} />
                                                )}
                                                    {/* <input type="submit" className="" id="" value="Approve" /> */}
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                </form>                        
                            </div>
                        </div>
                    </div> 
                    <div className="content-row row_padding_left row_padding_right full light-section" data-bgcolor="#eee">
                        <hr className="animated-line has-animation" />
                        <div className="one_third">
                            <h3 className="has-mask-fill no-margins">Details</h3>
                        </div>
                        <div className="two_third last">
                            <div className="one_third">
                                <h5 className="">Your HMMMM</h5>
                                <h6 className="no-margins">Total Balance</h6>
                                <h6 className="no-margins">Total Staked</h6>
                                <h6 className="no-margins">Rewards Earned</h6>
                                <h6 className="no-margins">Daily Potential</h6>
                                <h6 className="no-margins">Stake Cooldown</h6>
                                <h6 className="no-margins">Reward Cooldown</h6>
                            </div>
                            <div className="one_third">
                                <h5 className="">Your Value</h5>
                                <h6 className="no-margins">{balance}</h6>
                                <h6 className="no-margins">{staked}</h6>
                                <h6 className="no-margins">{earn}</h6>
                                <h6 className="no-margins">{dailyPotential}</h6>
                                <h6 className="no-margins">{stakedCooldown}</h6>
                                <h6 className="no-margins">{rewardCooldown}</h6>
                            </div>
                            <div className="one_third last">
                                <div className="button-box has-animation" data-delay="100">             
                                    <div className="clapat-button-wrap parallax-wrap hide-ball">
                                        <div className="clapat-button parallax-element">
                                            <div className="button-border rounded parallax-element-second">
                                                <input type="button" className="" id="" value="Get Rewards" onClick={handleRewards} />
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <hr />   
                        <div className="one_third"></div>
                        <div className="two_third last">
                            <div className="two_third">
                                <cite className="small">Staking HMMM earns you a 24% APY return, which can be collected after 7 days. Your tokens are locked for a staking period of 14 days, after which you may withdraw all funds. To increase your stake, you can either claim rewards or buy HMMM and add to your staking balance. When you unstake, your balance is reflected in your wallet.</cite>
                            </div>
                        </div>
                    </div> 
                </div>
                <div id="page-nav">
                    <div className="page-nav-wrap">
                        <div className="page-nav-caption content-full-width block-title marquee-title">                                 
                            <div className="inner">                                        
                                <a className="page-title next-ajax-link-page" data-type="page-transition" data-firstline="Next" data-secondline="Page" href="apps-portals.html">                                            
                                    <div className="next-hero-title-wrapper">
                                        <div className="next-hero-title">
                                            <span>Portals App is Coming Soon</span>
                                        </div>
                                    </div>
                                </a>
                                <div className="next-hero-subtitle-wrapper">
                                    <div className="next-hero-subtitle">
                                        <span>Unlock Portals rewards, discounts, and earnings when you hold HMMM.</span>
                                    </div>
                                </div>
                            </div>               
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    )
}

export default Staking;